import Vue from 'vue'
import { Input } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'

Vue.use(Input)

export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-input
        size="small"
        v-model="value"
        @focus="savePreviousData(value)"
        @keydown.tab="saveData"
        @keydown.enter="saveData"
        @blur="saveData"
        ref="txt-input"
        :autoFocus="true"
        :maxLength="maxLength"
      />
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      editorShow: true,
      savePreviousData: savePreviousData,
      keyCode: undefined,
      maxLength: 50,
    }
  },
  created() {
    this.value = this.params.value
    this.keyCode = undefined
    if (this.params.colDef.cellRendererParams.maxLength) {
      this.maxLength = this.params.colDef.cellRendererParams.maxLength
    }
  },
  methods: {
    saveData(event) {
      this.value = event.target.value
      if (!this.keyCode) {
        this.keyCode = event.keyCode
        switch (this.params.colDef['cellRendererParams'].type) {
          case 'dynamicTable':
            this.$root.$emit(
              'handleChange',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          case 'analysisSheet':
            this.$root.$emit(
              'saveAnalysisData',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.data.columnId,
              null,
              null,
              event.keyCode,
            )
            break
          case 'tenants':
            this.$root.$emit(
              'saveTenantData',
              this.params.colDef.field,
              event.target.value,
              this.params.colDef.headerName,
              this.params.data,
              event.keyCode,
            )
            break
          case 'projectTenants':
            this.$root.$emit(
              `saveTenantData${this.params.data.assetId}`,
              this.params.colDef.field,
              event.target.value,
              this.params.colDef.headerName,
              this.params.data,
              event.keyCode,
            )
            break
          case 'actualCostLevel':
            this.$root.$emit(
              'handleTileChange',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          case 'interiorGrouping':
            this.$root.$emit(
              'updateGrouping',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          case 'estimateGroup':
            this.$root.$emit(
              `onUpdateTakeoff${this.params.data.assetId}`,
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          case 'estimateTakeoff':
            this.$root.$emit(
              'onUpdateTakeoffs',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          case 'estimateGroups':
            this.$root.$emit(
              'updateEstimateGroup',
              event.target.value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              null,
              null,
              event.keyCode,
            )
            break
          default:
            break
        }
      }
    },

    getValue() {
      return this.value
    },
  },
})
